/**
 * imageService.js
 * 提供图片上传功能，使用腾讯云COS存储
 * 该服务负责处理图片的上传、删除和获取
 */

import COS from 'cos-js-sdk-v5';

// 复用已有的腾讯云COS配置
const COS_CONFIG = {
  SecretId: 'AKIDZ5OG3iDXfdPzObiePyLVYZO0QipidQzc',
  SecretKey: 'f8cy87vY2KRM5dz98vWwAC2g9QWP5Yr1',
  Bucket: 'xiaobaiwu-1317821739',
  Region: 'ap-chengdu',
  BaseUrl: 'https://xiaobaiwu-1317821739.cos.ap-chengdu.myqcloud.com'
};

// 初始化COS实例
const cos = new COS({
  SecretId: COS_CONFIG.SecretId,
  SecretKey: COS_CONFIG.SecretKey,
});

/**
 * 生成唯一的文件名
 * @param {string} originalName 原始文件名
 * @returns {string} 唯一文件名
 */
function generateUniqueFileName(originalName) {
  const timestamp = new Date().getTime();
  const randomStr = Math.random().toString(36).substring(2, 10);
  const ext = originalName.includes('.') 
    ? originalName.substring(originalName.lastIndexOf('.')) 
    : '';
  
  return `prompt-results/${timestamp}-${randomStr}${ext}`;
}

/**
 * 上传图片到腾讯云COS
 * @param {File} file 图片文件
 * @param {Function} onProgress 进度回调函数
 * @returns {Promise<Object>} 上传结果，包含URL和key
 */
const uploadImage = (file, onProgress) => {
  return new Promise((resolve, reject) => {
    const fileName = generateUniqueFileName(file.name);
    
    cos.putObject({
      Bucket: COS_CONFIG.Bucket,
      Region: COS_CONFIG.Region,
      Key: fileName,
      Body: file,
      onProgress: (progressData) => {
        if (onProgress) {
          onProgress(progressData.percent * 100);
        }
      },
    }, (err, data) => {
      if (err) {
        console.error('图片上传失败:', err);
        reject(err);
      } else {
        // 构建访问URL
        const url = `${COS_CONFIG.BaseUrl}/${fileName}`;
        resolve({
          url,
          key: fileName,
          name: file.name,
          size: file.size,
          type: file.type,
          uploadTime: new Date().toISOString()
        });
      }
    });
  });
};

/**
 * 删除腾讯云COS上的图片
 * @param {string} key 图片在COS上的键值
 * @returns {Promise<Object>} 删除结果
 */
const deleteImage = (key) => {
  return new Promise((resolve, reject) => {
    cos.deleteObject({
      Bucket: COS_CONFIG.Bucket,
      Region: COS_CONFIG.Region,
      Key: key,
    }, (err, data) => {
      if (err) {
        console.error('图片删除失败:', err);
        reject(err);
      } else {
        resolve({
          success: true,
          message: '图片删除成功',
          key
        });
      }
    });
  });
};

/**
 * 批量删除图片
 * @param {Array<string>} keys 图片键值数组
 * @returns {Promise<Object>} 批量删除结果
 */
const batchDeleteImages = (keys) => {
  if (!keys || keys.length === 0) {
    return Promise.resolve({ success: true, message: '没有图片需要删除' });
  }
  
  return new Promise((resolve, reject) => {
    cos.deleteMultipleObject({
      Bucket: COS_CONFIG.Bucket,
      Region: COS_CONFIG.Region,
      Objects: keys.map(key => ({ Key: key }))
    }, (err, data) => {
      if (err) {
        console.error('批量删除图片失败:', err);
        reject(err);
      } else {
        resolve({
          success: true,
          message: `成功删除${data.Deleted.length}张图片`,
          deleted: data.Deleted,
          errors: data.Error
        });
      }
    });
  });
};

// 导出服务函数
const ImageService = {
  uploadImage,
  deleteImage,
  batchDeleteImages
};

export default ImageService;
